<template>
  <div class="simulate-access">
    <div class="simulate-access__content">
      <div
        class="loading-container"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100vh;
        "
      >

        <div class="preloader-wrapper small active" style="margin-bottom: 40px;">
          <div class="spinner-layer forgot">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>

        <img src="@/assets/images/logo-pagtrust-white.png" alt="logo" style="width: 200px; margin-bottom: 20px;" />
      </div>
    </div>
  </div>
</template>

<script>
import { AuthService } from "@/services/auth.service";

export default {
  async mounted() {
    this.$gtag.pageview({
      page_title: "login",
      page_path: "/",
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("t")) {
      try {
        await AuthService.integrationLogin(urlParams.get("t"));
        await this.$store.dispatch("user/getCurrent");
        await this.$store.dispatch("notification/getNotifications");
        await this.$store.dispatch("config/getConfig");
        await this.$store.dispatch("user/updateProfilePic");
        await this.$store.dispatch("notification/initLoopTimeout");
        await this.$store.dispatch("enroll/getUserEnroll");
        await this.$store.dispatch("shopWindow/clearCurrent");
        await this.$store.dispatch("subscription/getUserSubscriptions");

        this.$router.push("/p/my-courses");
      } catch (error) {
        this.$store.commit("toast/NEW", {
          type: "error",
          message: error.message,
          page: "login",
        });
        this.$router.push({name: "login"});
      }
    } else {
      this.$store.commit("toast/NEW", {
        type: "error",
        message: "Token de integração não encontrado",
        page: "login",
      });
      this.$router.push({name: "login"});
    }
  },
};
</script>

<style lang="scss" scoped>
.simulate-access {
  width: 100%;
  height: 100vh;
  background: #000;
}
</style>
